// import React, { useState, useEffect } from 'react';
// import { useParams, useHistory, Link } from 'react-router-dom';
// // import { Card, CardContent, Button, Modal } from '@mui/material';
// import { Card, CardContent, Modal, Button } from '@material-ui/core';
// import { useAuth } from '../../../AuthContext';
// import { tokenIsExpired } from '../../../authUtils';
// import CopyrightIcon from '@mui/icons-material/Copyright';
// import PaidIcon from '@mui/icons-material/Paid';
// import ReceiptIcon from '@mui/icons-material/Receipt';
// import { fetchData, deleteData, activateData, SyncData, updateData } from '../../../apiService';
// import { Tooltip } from '@mui/material';
// import IconButton from '@mui/material/IconButton';
// import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
// import PersonIcon from '@mui/icons-material/Person';


// const customervacating = () => {
//   const { isAuthenticated, companyId, UserId, permissions, token, logout, roleName } = useAuth();
import React, { Fragment, useState, useContext, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData, deleteData, activateData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Card, CardContent, Modal } from '@mui/material';
import CopyrightIcon from '@mui/icons-material/Copyright';

function CustomerVacating() {   // const history = useHistory();

    /* API Call Post Method */
    const { isAuthenticated, companyId, UserId, logout, token } = useAuth();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }
    }, [isAuthenticated, companyId, UserId, token, logout, id]);

    useEffect(() => {
        fetchtableOCUUPIEDData();
    }, []);

    const [occupiedrooms, setOccupiedrooms] = useState([]);
    const fetchtableOCUUPIEDData = async () => {
        try {
            // const response = await fetchData('CustomerApi', `/RommDetails/${companyId}`, token);
            const response = await fetchData('ExpenseApi', `/FilledRooms/${companyId}`, token);
            if (response.responseCode === '1111') {
                setOccupiedrooms(response.response_data);
            }
            console.log(response.response_data);
        } catch (error) {
            console.error('Error fetching item details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };

    useEffect(() => {
        fetchtableFREEData();
    }, []);

    const [freerooms, setfreerooms] = useState([]);
    const fetchtableFREEData = async () => {
        try {
            const response = await fetchData('CustomerApi', `/RommDetails/${companyId}`, token);
            if (response.responseCode === '1111') {
                setfreerooms(response.response_data);
            }
            console.log(response.response_data);
        } catch (error) {
            console.error('Error fetching item details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };


    const [open, setOpen] = useState(false);
    const [vacatingRooms, setvacatingRooms] = useState([]);

    const handleOpen = async (roomId) => {
        setOpen(true);
        try {
            const response = await fetchData('CustomerApi', `/CustomerRoomDetails/${roomId}`, token);

            if (response.responseCode === '1111') {
                setvacatingRooms(response.response_data);
            } else {
                // Handle unexpected response codes
                console.error('Unexpected response code:', response.responseCode);
            }

            console.log(response);
        } catch (error) {
            console.error('Error fetching item details:', error);

            // Handle specific HTTP errors if needed
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");

    const CustomerRelationId = vacatingRooms.CustomerRelationId;

    const VacatingSubmit = async () => {
        setOpen(false);
        setIsLoading(true);
        const updatedFormData = {
            ID: vacatingRooms.CustomerRelationId,
            RoomId: vacatingRooms.RoomId,
            CustomerId: vacatingRooms.CustomerId,
            CreatedDate: vacatingRooms.Createddate,
            BillGenerateDate: vacatingRooms.Rentdate,
            CustomerRentAmount: vacatingRooms.RentAmount,
            CreatedBy: vacatingRooms.UserId,
            UpdatedBy: UserId,
            companyId: companyId,
        };

        try {
            await updateData('ReportApi', `${CustomerRelationId}`, updatedFormData, token);
            setSuccessMessages("Vacated successfully!");
            setErrorMessages("");
            setTimeout(() => {
                setSuccessMessages("");
                window.location.reload();
            }, 3000); // 3 seconds
        } catch (error) {
            console.error('Error updating record:', error);
            setIsLoading(false);
        }
    };


    const [roomDetailsopen, setroomDetailsopen] = useState(false);
    const [RoomsDetails, setRoomsDetails] = useState([]);

    const handleRoomOpen = async (roomId) => {
        setroomDetailsopen(true);
        try {
            const response = await fetchData('RoomApi', `/CustomerRoomDetails/${roomId}`, token);

            if (response.responseCode === '1111') {
                setRoomsDetails(response.response_data);
            } else {
                // Handle unexpected response codes
                console.error('Unexpected response code:', response.responseCode);
            }

            console.log(response);
        } catch (error) {
            console.error('Error fetching item details:', error);

            // Handle specific HTTP errors if needed
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };

    const handleRoomClose = () => {
        setroomDetailsopen(false);
    };

    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const handleVacateClick = () => {
        setConfirmationOpen(true);
    };

    const handleConfirmVacate = () => {
        setConfirmationOpen(false);
        VacatingSubmit();
    };

    const handleCancel = () => {
        setConfirmationOpen(false);
    };
    return (
        <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '730px', overflow: 'auto' }}>
            <style>
                {`
        /* Hide scrollbar for Chrome, Safari, and Opera */
        .container::-webkit-scrollbar {
          width: 0.1em;
        }

        .container::-webkit-scrollbar-track {
          background: rgba(255,255,255,0);
        }

        .container::-webkit-scrollbar-thumb {
          background-color: rgba(255,255,255,0);
          border-radius: 4px;
        }
      `}
            </style>
            <div className="flex flex-wrap justify-between">


            </div>
            <div className="flex flex-wrap justify-between">
                <Card className="w-full sm:w-3/4 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
                    <CardContent>
                        <div>
                            <h6 style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'darkred', fontWeight: 'bolder' }}>OCCUPIED ROOMS</h6>
                        </div>
                        <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {occupiedrooms && occupiedrooms.map((item) => (
                                <Card key={item.Id} className="customCard" style={{
                                    marginBottom: '10px',
                                    // background: 'linear-gradient(to right, darkred, black)',
                                    background: 'linear-gradient(to right, #FFBF78,#FFBF78)',
                                    color: 'black',
                                    // color: 'white',
                                    marginLeft: '30px',
                                    height: '60px',
                                    boxSizing: 'border-box',

                                    width: '100px',
                                    cursor: 'pointer'
                                }}
                                    //>
                                    onClick={() => handleOpen(item.ID)}>
                                    <CardContent style={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        alignItems: 'left',
                                        padding: '10px',
                                        boxSizing: 'border-box'
                                    }}>
                                        <div style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            textAlign: 'left'
                                        }}>
                                            {item.Name}
                                        </div>

                                    </CardContent>
                                </Card>
                            ))}
                        </div>
                    </CardContent>
                </Card>


                {/* Vacating  */}
                <Modal open={open} onClose={handleClose}>
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '80%',
                        maxWidth: '600px',
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                    }}>
                        <h5 style={{ fontFamily: 'time news roman', fontWeight: 'bolder' }}>ROOM DETAILS</h5>
                        <div style={{ padding: '10px 0' }}>
                            {vacatingRooms ? (
                                <div>
                                    <p style={{ margin: '10px 0' }}>
                                        <strong style={{ marginRight: '10px' }}>Customer:</strong>
                                        <strong style={{ color: 'darkmagenta' }}>{vacatingRooms.Customer}</strong>
                                    </p>
                                    <p style={{ margin: '10px 0' }}>
                                        <strong style={{ marginRight: '10px' }}>Room:</strong>
                                        <strong style={{ color: 'darkmagenta' }}>{vacatingRooms.RoomName}</strong>
                                    </p>
                                    <p style={{ margin: '10px 0' }}>
                                        <strong style={{ marginRight: '10px' }}>Rent Amount:</strong>
                                        <strong style={{ color: 'darkmagenta' }}>{vacatingRooms.RentAmount}</strong>
                                    </p>
                                    <p style={{ margin: '10px 0' }}>
                                        <strong style={{ marginRight: '10px' }}>Joining Date:</strong>
                                        <strong style={{ color: 'darkmagenta' }}>{formatDate(vacatingRooms.Joiningdate)}</strong>
                                    </p>
                                    <p style={{ margin: '10px 0' }}>
                                        <strong style={{ marginRight: '10px' }}>Leaving Date:</strong>
                                        {vacatingRooms.Leavingdate ? (
                                            <strong style={{ color: 'darkmagenta' }}>{formatDate(vacatingRooms.Leavingdate)}</strong>
                                        ) : (
                                            <strong style={{ color: 'darkmagenta' }}>Not Updated The Date</strong>
                                        )}
                                    </p>

                                </div>
                            ) : (
                                <p>Loading...</p>
                            )}
                        </div>

                        <Button onClick={handleVacateClick} style={{ backgroundColor: 'brown', color: 'white', marginLeft: '5px' }}>Vacate</Button>
                        {/* Confirmation Modal */}
                        <Modal open={confirmationOpen} onClose={handleCancel}>
                            <div style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '80%',
                                maxWidth: '400px',
                                backgroundColor: 'white',
                                padding: '20px',
                                borderRadius: '8px',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                            }}>
                                <h5 style={{ fontFamily: 'Times New Roman', fontWeight: 'bolder', textAlign: 'center' }}>Confirm Vacating</h5>
                                <p style={{ textAlign: 'center', marginBottom: '20px' }}>Are you sure you want to vacate this room?</p>
                                <div style={{ textAlign: 'center' }}>
                                    <Button onClick={handleConfirmVacate} style={{ backgroundColor: 'brown', color: 'white', marginRight: '10px' }}>Yes</Button>
                                    <Button onClick={handleCancel} variant="contained" color="primary">No</Button>
                                </div>
                            </div>
                        </Modal>
                        <Button onClick={handleClose} variant="contained" color="primary" style={{ marginLeft: '5px' }}>Close</Button>

                    </div>
                </Modal>

                <Card className="w-full sm:w-1/5 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
                    <CardContent>
                        <div>
                            <h6 style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'darkgreen', fontWeight: 'bolder' }}>AVAILABLE ROOMS</h6>
                        </div>
                        <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {freerooms && freerooms.map((item) => (
                                <Card key={item.Id} className="customCard" style={{
                                    marginBottom: '10px',
                                    // backgroundColor: '#3D550C',
                                    background: 'linear-gradient(to right, #B0EBB4, #B0EBB4)',
                                    // color: 'white',
                                    color: 'black',
                                    marginLeft: '20px',
                                    height: '60px',
                                    boxSizing: 'border-box',
                                    // '@media (min-width: 600px)': {
                                    //     width: 'calc(20% - 20px)'
                                    // }
                                    width: '100px',
                                    cursor: 'pointer'
                                }}

                                    onClick={() => handleRoomOpen(item.ID)}>
                                    <CardContent style={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        alignItems: 'left',
                                        padding: '10px',
                                        boxSizing: 'border-box'
                                    }}>
                                        <div style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            textAlign: 'left'
                                        }}>
                                            {item.Name}
                                        </div>

                                    </CardContent>
                                </Card>
                            ))}
                        </div>
                    </CardContent>
                </Card>
                <Modal open={roomDetailsopen} onClose={handleRoomClose}>
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '80%',
                        maxWidth: '600px',
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                    }}>
                        <h5 style={{ fontFamily: 'time news roman', fontWeight: 'bolder' }}>ROOM DETAILS</h5>
                        <div style={{ padding: '10px 0' }}>
                            {RoomsDetails ? (
                                <div>
                                    <p style={{ margin: '10px 0' }}>
                                        <strong style={{ marginRight: '10px' }}>Room :</strong>
                                        <strong style={{ color: 'darkmagenta' }}>{RoomsDetails.Name}</strong>
                                    </p>
                                    <p style={{ margin: '10px 0' }}>
                                        <strong style={{ marginRight: '10px' }}>Details:</strong>
                                        <strong style={{ color: 'darkmagenta' }}>{RoomsDetails.Description}</strong>
                                    </p>
                                    <p style={{ margin: '10px 0' }}>
                                        <strong style={{ marginRight: '10px' }}>Rent Amount:</strong>
                                        <strong style={{ color: 'darkmagenta' }}>{RoomsDetails.RentAmount}</strong>
                                    </p>

                                </div>
                            ) : (
                                <p>Loading...</p>
                            )}
                        </div>
                        <Button onClick={handleRoomClose} variant="contained" color="primary" style={{ marginLeft: '5px' }}>Close</Button>

                    </div>
                </Modal>

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>
            </div>
        </div >
    );

};

export default CustomerVacating;

